'use client';
import { BaseImage } from '@/components/baseImage/BaseImage';
import { Link } from '@/components/link/Link';
import { VideoPlayer } from '@/components/video-player/VideoPlayer';
import { StackedMediaHeroProps } from '@/components/hero/types';
import { Headline } from '@/components/headline/Headline';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';

export default function StackedMediaHero({
  headline,
  description,
  image,
  video,
  link,
  textAlign = 'left',
  sectionBackgroundColor,
  spacingTop,
  spacingBottom,
  sectionId,
}: StackedMediaHeroProps) {
  return (
    <div
      id={sectionId}
      className={`relative z-10 w-full bg-${sectionBackgroundColor}`}
    >
      <div className="container mx-auto px-4 sm:px-0">
        <div
          className={`${
            spacingTop ? 'pt-4 md:pt-8 lg:pt-20' : ''
          } ${spacingBottom ? 'pb-4 md:pb-8 lg:pb-20' : ''}`}
        >
          <div
            className={`mb-8 ${textAlign === 'left' ? 'flex flex-col items-start' : 'flex flex-col items-center text-center'} mt-6 md:mb-12 md:mt-0`}
          >
            <div
              className={`flex flex-col gap-6 ${textAlign === 'left' ? 'flex flex-col items-start' : 'flex flex-col items-center text-center'} `}
            >
              <Headline
                {...headline}
                className="!my-0 text-2xl font-bold text-brand-700"
              >
                {headline.title}
              </Headline>
              {description && (
                <div className="stacked-media-content serialize-description mb-6 lg:w-3/4">
                  <SerializeDescription description={description} />
                </div>
              )}
            </div>
            {link && (
              <div className="split-image-hero__link w-fit lg:mb-4">
                {link && (
                  <div className="split-image-hero__link w-fit lg:mb-4">
                    {link && <Link {...link} className="px-0" />}
                  </div>
                )}
              </div>
            )}
          </div>
          {video && image ? (
            <VideoPlayer
              {...video}
              aspectRatio="16:9"
              classNameVideoWrapper="rounded-lg h-full"
              className={`aspect-[1/1] w-full object-cover !px-0 md:aspect-[4/3] lg:aspect-[16/9]`}
            />
          ) : image ? (
            <BaseImage
              {...image}
              prerender={true}
              className="aspect-[16/10] h-full w-full overflow-hidden rounded-2xl object-cover sm:aspect-[2/1]"
              classNameImage="w-full h-full object-cover"
              sizes="100vw"
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}
